<div class="main-layout-container" [class.sidenav-collapsed]="!sidenavExpanded">
  <div class="sidenav-container">
    <app-sidenav [isExpanded]="sidenavExpanded" (toggleSidenav)="onSidenavToggle($event)"></app-sidenav>
  </div>
  <div class="content-area">
    <!-- <header class="main-header"> -->
      <!-- <div class="header-content"> -->
        <app-header  (toggleSidenav)="onSidenavToggle($event)"></app-header>
      <!-- </div> -->
    <!-- </header> -->
    <main class="main-content">
      <app-loader></app-loader>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
